import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { changeConfiguration } from "api/appSetupService";
import { normalizeLanguage } from "utils/locale";
export const useLanguageManager = (initialLanguage) => {
    const { i18n } = useTranslation();
    const safeInitialLanguage = normalizeLanguage(initialLanguage);
    const [currentLanguage, setCurrentLanguage] = useState(safeInitialLanguage);
    const languageLabels = {
        pt: "Português",
        "pt-BR": "Português",
        en: "English",
        "en-US": "English",
        es: "Español",
        "es-ES": "Español",
    };
    useEffect(() => {
        // Se tiver um idioma armazenado no backend
        if (initialLanguage) {
            // Prioriza o valor do backend
            const safeLanguage = normalizeLanguage(initialLanguage);
            setCurrentLanguage(safeLanguage);
            i18n.changeLanguage(safeLanguage);
            localStorage.setItem("i18nextLng", safeLanguage);
        }
        else {
            // Se não houver valor do backend, usa o localStorage
            const storedLanguage = localStorage.getItem("i18nextLng");
            if (storedLanguage) {
                const safeStoredLanguage = normalizeLanguage(storedLanguage);
                setCurrentLanguage(safeStoredLanguage);
                i18n.changeLanguage(safeStoredLanguage);
                localStorage.setItem("i18nextLng", safeStoredLanguage);
            }
            else {
                const browserLang = navigator.language?.split('-')[0].toLowerCase(); // Ex: pega 'pt' de 'pt-BR'
                const fallbackLang = normalizeLanguage(browserLang);
                setCurrentLanguage(fallbackLang);
                i18n.changeLanguage(fallbackLang);
                localStorage.setItem("i18nextLng", fallbackLang);
            }
        }
    }, [initialLanguage, i18n]);
    const changeLanguage = async (newLang) => {
        try {
            // await changeConfiguration({ language: newLang });
            const safeNewLang = normalizeLanguage(newLang);
            await i18n.changeLanguage(safeNewLang);
            setCurrentLanguage(safeNewLang);
            localStorage.setItem("i18nextLng", safeNewLang);
            return true;
        }
        catch (error) {
            return false;
        }
    };
    const getCurrentLanguageLabel = () => {
        return languageLabels[currentLanguage] || languageLabels["pt"];
    };
    return {
        currentLanguage,
        changeLanguage,
        getCurrentLanguageLabel,
        languageLabels,
        languageOptions: [
            { label: "Português", value: "pt" },
            { label: "English", value: "en" },
            { label: "Español", value: "es" },
        ],
    };
};
